import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AuthLogWidget } from '@/widgets/auth-log-widget'

export const Route = createFileRoute('/_auth/journal/tabs/auth')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <AuthLogWidget />
      <Outlet />
    </>
  )
}
